import { motion } from "framer-motion";
import Styles from "./Backdrop.module.css";
import { connect } from "react-redux";

/**
 * Backdrop Component
 * ------------------
 * A reusable animated backdrop overlay using Framer Motion.
 * 
 * Props:
 * - children: ReactNode — Content to render inside the backdrop.
 * - onClick: Function — Triggered when the user clicks on the backdrop.
 * - theme: boolean — Boolean value from Redux store determining theme mode.
 *                   Currently not used directly but available for future styling logic.
 */
const Backdrop = ({ children, onClick, theme }: any) => {
  return (
    <motion.div
      onClick={onClick}
      className={Styles.backdrop}
      style={{
        // Semi-transparent dark background overlay
        backgroundColor: "#000000e1"
      }}
      /** Initial animation state */
      initial={{ opacity: 0 }}

      /** Animation on mount */
      animate={{ opacity: 1 }}

      /** Animation on unmount */
      exit={{ opacity: 0 }}
    >
      {children}
    </motion.div>
  );
};

/**
 * Maps Redux state to component props
 * -----------------------------------
 * Extracts theme mode (light/dark) from Redux store.
 */
const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode,
  };
};

// Export component wrapped with Redux connect()
export default connect(mapStateToProps)(Backdrop);
